import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "field", "md"]

  connect () { 
    let _this = this;

    if (_this.hasFieldTarget ) { 

      //Dependent field
      if (_this.fieldTarget.classList.contains("dependent")) {
        let trigger_id,
            trigger_val,
            trigger;

        trigger_id = _this.fieldTarget.dataset.triggerId;
        trigger_val = _this.fieldTarget.dataset.triggerValue;
        trigger = document.getElementById("field_" + trigger_id);

        if (trigger != undefined) {
          setTimeout(function() {checkDependences();}, 200);

          trigger.addEventListener('change', function() {
            checkDependences();
          });
        }

        function checkDependences() {
          if (trigger.querySelector("[data-field-target='md']").value == trigger_val) {
            _this.fieldTarget.classList.remove('disabled');
            _this.fieldTarget.querySelectorAll("[data-field-target='md']").forEach(function (el) {
              el.disabled = false;
            });
          } else {
            _this.fieldTarget.classList.add('disabled');
            _this.fieldTarget.querySelectorAll("[data-field-target='md']").forEach(function (el) {
              el.disabled = true;
            });
          }
        }
      }

    }

  }

}